export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const calculateProgress = (current: number, total: number): number => {
  // Calculamos el progreso para que vaya en sentido horario
  return ((total - current) / total) * 100;
};